import React from "react";

export default function Content({ children }) {
  return <>{children}</>;
}
